import React, { useCallback, useRef, useState } from 'react'

import { ProviderInNetworkVerificationModal } from '../ProviderInNetworkVerificationModal/ProviderInNetworkVerificationModal'
import { ProviderSearchModal } from '../ProviderSearchModal'

export type UseProviderInNetworkVerificationModalProps = {
  planIds: string[];
  onSelectMorePlansForVerification?: () => void;
}

export type UseProviderInNetworkVerificationModalReturn = {
  launchModal: (props: UseProviderInNetworkVerificationModalProps) => void;
  modal: React.ReactNode;
}

export const useProviderInNetworkVerificationModal = (
  setSelectedPlanIds: React.Dispatch<React.SetStateAction<string[]>>
): UseProviderInNetworkVerificationModalReturn => {
  const [verificationModalOpen, setVerificationModalOpen] = useState(false)
  const [providerSearchModalOpen, setProviderSearchModalOpen] = useState(false)
  const onSelectMorePlansForVerificationRef = useRef<UseProviderInNetworkVerificationModalProps['onSelectMorePlansForVerification']>()
  const launchModal = useCallback((props: UseProviderInNetworkVerificationModalProps) => {
    const { planIds, onSelectMorePlansForVerification } = props
    onSelectMorePlansForVerificationRef.current = onSelectMorePlansForVerification
    window.segment?.track('InNetworkProviderVerification - modal open')
    setVerificationModalOpen(true)
    setSelectedPlanIds(planIds)
  }, [setSelectedPlanIds])

  return {
    launchModal,
    modal: (
      <>
        <ProviderInNetworkVerificationModal
          open={verificationModalOpen}
          onOpenChange={setVerificationModalOpen}
          openProviderSearchModal={() => {
            setVerificationModalOpen(false)
            setProviderSearchModalOpen(true)
          }}
          onSelectMorePlansForVerification={() => {
            onSelectMorePlansForVerificationRef.current?.()
            setVerificationModalOpen(false)
          }}
        />
        <ProviderSearchModal
          open={providerSearchModalOpen}
          onOpenChange={(open) => {
            if (!open) setVerificationModalOpen(true)
            setProviderSearchModalOpen(open)
          }}
        />
      </>
    ),
  }
}
